<template>
  <div class="c-group">
    <filters
      :placeholder="`请输入${open}名称`"
      :dataSource="dataSource"
      :billing="billing"
      @on-change="filterData"
      @on-search="searchFilterData"
    />
    <div class="control-btns">
      <div>
        <ElButton type="primary" @click="openNewEntry">新建计划</ElButton>
        <Dropdown @on-click="betch" style="margin: 0 10px">
          <ElButton>
            批量操作
            <Icon type="ios-arrow-down"></Icon>
          </ElButton>
          <DropdownMenu slot="list">
            <DropdownItem :name="1">启用</DropdownItem>
            <DropdownItem :name="0">暂停</DropdownItem>
            <DropdownItem :name="-1">删除</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
      <ElButton @click="modalColumn = true">自定义列</ElButton>
    </div>
    <!-- 表格列表 -->
    <div class="c-table-list">
      <Viewport v-model="tableHeight">
        <ad-table
          ref="adTable"
          :value="spining"
          :data="planList"
          :columns="tableCol"
          :invenType="invenType"
          :statusData="statusData"
          :height="tableHeight"
          @on-sort="sortTable"
          @on-refresh="getData"
          @header-dragend="headerDragend"
        />
        <Page
          show-total
          show-sizer
          show-elevator
          :total="total"
          :current.sync="pageIndex"
          :page-size="pageSize"
          :page-size-opts="[10, 20, 30, 40, 100]"
          @on-change="changePageIndex"
          @on-page-size-change="changePageSize"
          class="c-table-page pager"
          size="small"
        />
      </Viewport>
    </div>
    <custom-column v-model="modalColumn" :data="columns" @on-select="selectColumn" :subTitle="['基础数据', '计划数据', '其他数据']" />
  </div>
</template>
<script>
import mixin from './mixin'
import { invenType, projectStatusData } from './data/constant.js'
import { isArray } from '@/common/js/utils'
import { TOUTIAO_AD } from '../data/tencentv3_ad_column'
import { queryMediaProjectList } from '@/api/convert.model'
import { adGames, adAccount, adPtom } from '@/api/common.model'
import Filters from './components/ad-filter.vue'
import AdTable from './components/ad-table.vue'
import CustomColumn from '@/components/converter/custom-column.vue'

export default {
  name: 'TencentAd',
  mixins: [mixin],
  components: { Filters, CustomColumn, AdTable },
  computed: {
    mediaVal() {
      return 16
    },
    open() {
      return '计划'
    },
    // 存local用户自定义列
    custom() {
      return 'tencentv3Ad'
    },
    tableCol() {
      return this.columns.filter((ret) => !ret.show)
    },
    billing() {
      let pricing
      if (this.mediaVal === 10) pricing = ['OCPC', 'CPC', 'OCPM', 'CPM']
      return pricing
    }
  },
  watch: {
    columns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => `${met.key}${met.width ? `|${met.width}` : ''}`)
        this.setCustomStorage(`${this.custom}CustomColumn`, show)
        this.$nextTick(() => {
          this.$refs.adTable && this.$refs.adTable.doLayout()
        })
      },
      deep: true
    }
  },
  methods: {
    // 自定义列 全选
    selectColumnAll(params) {
      const { type, show } = params
      const data = this.columns.filter((ret) => ret.type === type)
      data.forEach((ret) => {
        this.$set(ret, 'show', show)
      })
    },
    getData(filter) {
      let params = {
        subMediaId: 3,
        mediaId: this.mediaVal,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sort: this.sort,
        order: this.order
      }

      if (filter) params = Object.assign(params, filter)
      else if (this.params) params = Object.assign(this.params, params)

      // 广告组id
      if (this.id) params = Object.assign(params, { adGroupId: this.id })

      // 账号id
      if (this.adAccountId) params.adAccountId = this.adAccountId

      // 保存参数
      this.params = JSON.parse(JSON.stringify(params))
      // 请求数据
      this.spining = true
      queryMediaProjectList(
        Object.assign(params, {
          selectJson: JSON.stringify(params)
        })
      ).then((data) => {
        this.spining = false
        if (data && data.list && data.page_info) {
          // eslint-disable-next-line
          const { total_number } = data.page_info
          this.planList = data.list.map((ret) => {
            ret.optStatus = ret.optStatus === 1
            ret.budgetFlag = parseInt(ret.budget) > 0 ? 1 : 0
            ret.bid = ret.bid === 0 ? '-' : ret.bid
            ret.roiRatio = ret.deepConversionType === '付费ROI' || ret.ocpxActionType === '付费ROI' ? ret.roiRatio : '-'
            return ret
          })
          // eslint-disable-next-line
          this.total = total_number ? total_number : 0
          this.$nextTick(() => {
            this.$refs.adTable && this.$refs.adTable.doLayout()
          })
        }
      })
    },
    changePageIndex(index) {
      this.pageIndex = index
      this.getData()
    },
    changePageSize(size) {
      this.setLocalPage(size)
      this.pageSize = size
      if (this.pageIndex === 1) this.getData()
    },
    betch(type) {
      if ([1, 0, -1].includes(type)) {
        this.$refs.adTable.changeBetch(type)
      }
    },
    preload() {
      Promise.all([adGames({ type: 1 }), adAccount({ authFlag: 1, mediaId: 16 }), adPtom({ authFlag: 1 })])
        .then((data) => {
          const [gameData, accountData, opData] = data
          if (isArray(opData)) {
            this.dataSource.opData = opData.map((op) => ({ ...op, id: op.opId }))
          }
          isArray(gameData) && (this.dataSource.gameData = gameData)
          isArray(accountData) && (this.dataSource.accountData = accountData)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  data() {
    return {
      tableHeight: 330,
      id: this.$router.currentRoute.query.id,
      adAccountId: this.$router.currentRoute.query.adAccountId,
      modalColumn: false, // 自定义列
      spining: null, // 表格数据加载
      planList: [], // 投放计划列表
      columns: [],
      invenType: invenType,
      statusData: projectStatusData,
      dataSource: {
        accountData: [],
        opData: [],
        gameData: [],
        statusData: projectStatusData
      }
    }
  },
  created() {
    // 预加载数据
    this.preload()
    // 表格列数据
    const columns = TOUTIAO_AD
    this.$store.commit('Convert/setMedia', String(this.mediaVal))
    const shows = this.getCustomStorage(`${this.custom}CustomColumn`)
    // 同步本地存储自定义列
    if (shows.length) {
      this.columns = columns
        .sort((a, b) => {
          const idxA = shows.findIndex((ret) => ret.includes(a.key))
          const idxB = shows.findIndex((ret) => ret.includes(b.key))
          const sortA = idxA < 0 ? idxA : shows.length - idxA
          const sortB = idxB < 0 ? idxB : shows.length - idxB
          return sortB - sortA
        })
        .map((ret) => {
          const shifRet = shows.filter((met) => met && met.includes('|') && met.includes(ret.key)).shift()
          ret.show = !shows
            .filter((met) => met)
            .map((met) => (met.includes('|') ? met.split('|').shift() : met))
            .includes(ret.key)
          shifRet && (ret.width = parseInt(Number(shifRet.split('|').pop() || '')))
          return ret
        })
    } else {
      this.columns = [...columns]
    }
    // 列表请求
    this.getData()
  }
}
</script>
<style lang="scss" scoped>
.c-group {
  .control-btns {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  .c-table-page {
    padding: 5px 0;
    text-align: right;
  }

  .ivu-badge {
    ::v-deep .badge-alone {
      background: #5cb85c !important;
    }
  }

  ::v-deep .el-input--mini .el-input__inner {
    padding: 0 4px;
  }
}
</style>
